module.exports = __webpack_public_path__ + "static/media/wode1.0ab9892a.png";